module.exports = __webpack_public_path__ + "img/ods_logo.3ffb1137.png";